<template>
	<div>
		<CoverageMap />
		<v-row class="mt-6">
			<!-- Download ENC -->
			<v-col cols="6">
				<NavCard
					subTitle="Download the weekly PRIMAR CD content"
					title="PRIMAR CD Service"
					icon="mdi-download"
					_blank
					linkTo="https://primar.ecc.no/primar/portal/public/enc/downloadEnc.jsf"
				/>
			</v-col>

			<v-col cols="6">
				<NavCard
					_blank
					linkTo="https://primar.ecc.no/primar/"
					outlined
					subTitle="Go to the ENC distribution centre"
					title="PRIMAR Portal"
					icon="mdi-earth"
				/>
			</v-col>
		</v-row>
	</div>
</template>
<script>
import NavCard from '@/components/home/NavCard'
import CoverageMap from '@/components/CoverageMap'

export default {
	name: 'Coverage',

	components: {
		NavCard,
		CoverageMap
	},

	metaInfo: {
		title: 'Coverage'
	},
	methods: {}
}
</script>

<style lang="scss" scoped></style>
